/* NS Custom Js */

document.addEventListener('DOMContentLoaded', function (e) {
  // Dirty solution to close menu on mobiles
  const nsMobileMenuShopLink = document.querySelector('#HeaderDrawer-shop');
  const nsMobileMenu = document.querySelector('#Details-menu-drawer-container summary');

  if (nsMobileMenuShopLink && nsMobileMenu) {
    nsMobileMenuShopLink.addEventListener(
      'click',
      function () {
        nsMobileMenu.click();
      },
      { passive: true }
    );
  }

  // Open ingredients disclosure on product page.
  const ingredientsDisclosure = document.querySelector('.product__accordion details'); // Get 1st details element.
  if (ingredientsDisclosure) {
    ingredientsDisclosure.open = true;
  }
});
